import React from 'react'

const TextInputWrapper = React.forwardRef((props, ref) => (
  <div className='form-group'>
    <div className='col-sm-12'>
      <label className='region-label'>
        {props.label}
        <input className='form-control' {...props} ref={ref} />
      </label>
    </div>
  </div>
))

export default TextInputWrapper
